import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import auth from './auth/index';
import course from './course';
import faqs from './faqs';
import event from './event';
import catalog from './catalog';
import ui from './ui';
import memberships from './memberships';
import registration from './registration';
import member from './member';
import author from './author';
import credential from './credential';
import promo from './promo';
import memberEvents from '@/modules/member/event/store';

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',

    modules: {
        auth, course, faqs, event, catalog, ui,
        memberships, registration, author,
        memberEvents,
        'member.wishlist': member.wishlist,
        'member.courses': member.courses,
        credential, promo
    }
});